/**
 * Reading an override's auth bundles on the client (FIQ-1926).
 *
 * The server sends `bundleIds` and a parallel `bundleNames` — parallel rather than combined
 * because a name is genuinely absent when the bundle has been deleted since the override was
 * written, and the row still has to show that the override names it.
 *
 * Both the client-admin Access tab and the staff overrides report render the same two things
 * from a grant, so they share the reading of it: two screens quietly disagreeing about what an
 * override confers is exactly the confusion this feature exists to remove.
 */

/**
 * @returns {Array<{id: string, name: string|null}>} one entry per bundle the override names
 */
export function listGrantBundles(grant) {
    const names = grant?.bundleNames ?? []
    return (grant?.bundleIds ?? []).map(toBundle)

    function toBundle(id, index) {
        return { id, name: names[index] ?? null }
    }
}

/**
 * Everything the override confers: the demands picked by hand, plus whatever its bundles
 * resolved to. An override may carry both, so neither source alone describes the row.
 */
export function grantConferredDemands(grant) {
    return [...new Set([...(grant?.demands ?? []), ...(grant?.resolvedDemands ?? [])])]
}
